/** FR-05.8: public company profiles and directory cards share industry artwork when no cover is saved. */
export function companyCoverImage(primaryIndustry?: string | null): string {
  const industry = primaryIndustry?.toLowerCase() ?? "";
  if (industry.includes("construction")) return "/hero/construction.jpg";
  if (industry.includes("electrical") || industry.includes("energy")) return "/hero/electrical.jpg";
  if (industry.includes("plumbing")) return "/hero/plumbing.jpg";
  if (industry.includes("home") || industry.includes("cleaning")) return "/hero/home-service.jpg";
  if (industry.includes("professional") || industry.includes("consult")) return "/hero/professional-services.jpg";
  return "/hero/banner-bg.jpg";
}
